module.exports = __webpack_public_path__ + "static/media/jdrManoir_01_full.c227ad02.gif";